module.exports = __webpack_public_path__ + "img/quality-monitoring.d90e6d5.png";